import { Router } from '@angular/router';
import { Component, Inject } from '@angular/core';
import { RedirectRequest } from '@azure/msal-browser';
import { LoginService } from 'src/app/services/login.service';
import { MsalService, MsalGuardConfiguration, MSAL_GUARD_CONFIG, } from '@azure/msal-angular';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
  
export class LoginComponent {
  email: string = '';
  password: string = '';
  token: any;
  isUserLoggedIn: boolean = false;
  private isAuthenticated: boolean = false;

  constructor(
    private router: Router,
    private msalService: MsalService,
    private loginService: LoginService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration) {
    this.msalService.initialize();
  }

  ngOnInit() {
    this.getLoginAD();
  }

  async getLoginAD() {
    this.msalService.handleRedirectObservable()
      .subscribe({
        next: async (response) => {
          if (response == null) {
            this.loginService.logout();
          } else {
            this.loginBackend(response);
          }
        },error: (err) => {
          console.warn(err);
        }
      });
  }

  login() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  logout() {
    localStorage.clear();
    this.isAuthenticated = false;
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }

  async loginBackend(getADMicrosoft: any) {
    try {
      const result = await this.loginService.logintoken(getADMicrosoft);
      this.router.navigate(['/home']);
    } catch (error) {
      this.loginService.logout();
      this.router.navigate(['/error'])
    }
  }

  isUserInAuthorizedGroup(): boolean {
    const user = this.msalService.instance.getActiveAccount();
    if (user && user.idTokenClaims) {
      const groups = user.idTokenClaims["groups"];
      if (groups && Array.isArray(groups)) {
        return groups.includes('id-del-grupo-autorizado');
      }
    }
    return false;
  }

}
